import { IFIReportType } from '@cims-online/shared'
import useNotImported from '../useNotImported'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'

const useAsphaltLotPanel = (): CIMSCollapsePanelOptions =>
  useNotImported({
    id: IFIReportType.AsphaltLot.id,
    type: IFIReportType.AsphaltLot.type,
  })

export default useAsphaltLotPanel
